import { CitiesRequest } from '@common/model/location/citiesRequest';
import { useMemo } from 'react';
import { coreLocationApi } from '../api';

export type Option = { value: number; label: string; disabled?: boolean };

export const useCityOptions = (req: CitiesRequest = {}): Option[] => {
  const { data } = coreLocationApi.endpoints.getCities.useQuery(req);
  return useMemo(() => {
    if (!data) {
      return [{ value: 0, label: 'Loading...', disabled: true }];
    }
    return data.map((city) => ({ value: city.id, label: city.translation.name }));
  }, [data]);
};
